import { LoadingButton } from "@mui/lab";
import { Avatar, Box, Container, CssBaseline, Link, TextField, Typography } from "@mui/material";
import { useLoginMutation } from "api/authApi";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCredentials } from "store/authSlice";
import runJoiValidate from "utils/runJoiValidate";
import { ADMIN_LOGIN_SCHEMA } from "./ValidationSchemas";

export default function Login() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [login, { isLoading, error }] = useLoginMutation()
    const [user, setUser] = useState({
        email: '',
        password: ''
    })
    const [validationErrors, setValidationErrors] = useState(null)

    const handleChange = ({ target: { name, value } }) => {
        setUser(prevUser => ({
            ...prevUser,
            [name]: value
        }))
    }
    const handleSubmit = async (event) => {
        try {
            event.preventDefault();
            setValidationErrors(null)
            const errors = runJoiValidate(ADMIN_LOGIN_SCHEMA, user)
            if (!!errors) {
                setValidationErrors(errors)
                return
            }
            let response = await login(user).unwrap()
            dispatch(setCredentials(response?.body))
            navigate("/admin")
        } catch (error) {
            console.log("error login")
            console.log(error)
        }
    }
    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 50,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Avatar src="/images/Logo.png" alt="logo" sx={{ width: 100, height: 100 }} />
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        size="small"
                        value={user?.email}
                        onChange={handleChange}
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label={t("Email")}
                        name="email"
                        autoComplete="email"
                        autoFocus
                        error={!!validationErrors?.email}
                        helperText={validationErrors?.email}
                    />
                    <TextField
                        size="small"
                        value={user?.password}
                        onChange={handleChange}
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label={t("Password")}
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        error={!!validationErrors?.password}
                        helperText={validationErrors?.password}
                    />
                    <LoadingButton
                        type="submit"
                        loading={isLoading}
                        fullWidth
                        variant="contained"
                        sx={{ my: 15 }}
                    >
                        {t("Log In")}
                    </LoadingButton>
                    {!!error &&
                        <Box textAlign="center">
                            <Typography color="error">{t(error)}</Typography>
                        </Box>
                    }
                    {/* <Grid container>
                        <Grid item xs>
                            <Link href="#" variant="body2">
                                {t("Forgot password?")}
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link href="#" variant="body2">
                                {t("Don't have an account? Sign Up")}
                            </Link>
                        </Grid>
                    </Grid> */}
                </Box>
            </Box>
            <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 18, mb: 4 }}>
                {'Copyright © '}
                <Link color="inherit" href="">
                    Freshoe
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
        </Container>
    )
}